// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AppearancePicker: MarkdocTagRegistration = {
  tag: 'appearance-picker',
  component: 'AppearancePicker',
  selfClosing: true,
  attributes: {},
};
